import { useState, useEffect } from 'react'
import { useParams, Navigate, Link } from 'react-router-dom'
import Swal from 'sweetalert2'

import { getProjects, getProjectCategory } from '../../services/firebase.js'

import Loader from '../Loader/Loader'
import ProjectList from '../ProjectList/ProjectList'
import './ProjectListContainer.css'

function ProjectListContainer() {
    const [ projects , setProjects ] = useState([])
    const [ isLoading , setIsLoading ] = useState(true)
    const [ errorText, setErrorText ] = useState(null)
    const { categoryId } = useParams()

    useEffect(() => {
        async function requestProjects() {
            setIsLoading(true)
            try {
                let response = categoryId
                ? await getProjectCategory(categoryId)
                : await getProjects()
                setProjects(response)
            } catch(error) {
                setErrorText(error.message)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No pudimos encontrar esa categoría',
                    showConfirmButton: false,
                    timer: 1500,
                    footer: ''
                    })
            } finally {
                setIsLoading(false)
            }
        }
        requestProjects()
    }, [ categoryId ])

    if (isLoading) {
        return (
            <Loader />
        )
    }

    if (errorText) {
        return (
            <Navigate to='/' />
        )
    } else {
        return (
            <div className='project-list-container'>
                <div className='menu-items'>
                        <Link to='/category/habitacional' className='menu-btn'>Habitacional</Link>
                        <Link to='/category/comercial' className='menu-btn'>Comercial</Link>
                        <Link to='/category/industrial' className='menu-btn'>Industrial</Link>
                        <Link to='/projects' className='menu-btn'>Ver Todos</Link>
                    </div>
                <ProjectList projects={ projects } />
            </div>
        )
    }
}

export default ProjectListContainer